<template>
    <div>
        <h2 class="dd-m-modal--offline__title dd-m-modal--offline__title--sm">
            Application efficiency with the lightness of the web
        </h2>

        <div class="dd-m-modal--offline__description">
            Progressive Web Apps (PWA) unem o melhor da web com uma experiência mobile que é pura praticidade. Quer
            saber mais? Confira abaixo os principais benefícios desse novo modo de fazer aplicativos:
        </div>

        <h2 class="dd-m-modal--offline__title dd-m-modal--offline__title--sm dd-m-modal--offline__title--dot">
            App-like website
        </h2>

        <div class="dd-m-modal--offline__description">
            Navigation and appearance similar to that of a common App.
        </div>

        <h2 class="dd-m-modal--offline__title dd-m-modal--offline__title--sm dd-m-modal--offline__title--dot">
            Installable
        </h2>

        <div class="dd-m-modal--offline__description">
            PWA can be installed in seconds.
        </div>

        <h2 class="dd-m-modal--offline__title dd-m-modal--offline__title--sm dd-m-modal--offline__title--dot">
            Straight to the point
        </h2>

        <div class="dd-m-modal--offline__description">
            You enjoy the resources available in a simple and direct way.
        </div>

        <h2 class="dd-m-modal--offline__title dd-m-modal--offline__title--sm dd-m-modal--offline__title--dot">
            Progressive
        </h2>

        <div class="dd-m-modal--offline__description">
            It becomes an application as you interact with the application.
        </div>

        <h2 class="dd-m-modal--offline__title dd-m-modal--offline__title--sm dd-m-modal--offline__title--dot">
            Light
        </h2>

        <div class="dd-m-modal--offline__description">
            It occupies little and space and has low consumption of mobile data.
        </div>

        <h2 class="dd-m-modal--offline__title dd-m-modal--offline__title--sm dd-m-modal--offline__title--dot">
            Accessible
        </h2>

        <div class="dd-m-modal--offline__description">
            Works well on any connection and even offline.
        </div>

        <h2 class="dd-m-modal--offline__title dd-m-modal--offline__title--sm dd-m-modal--offline__title--dot">
            Responsive
        </h2>

        <div class="dd-m-modal--offline__description">
            Adaptable to any type and format of device.
        </div>

        <h2 class="dd-m-modal--offline__title dd-m-modal--offline__title--sm dd-m-modal--offline__title--dot">
            Rapid
        </h2>

        <div class="dd-m-modal--offline__description">
            PWA is fast and dynamic.
        </div>

        <h2 class="dd-m-modal--offline__title dd-m-modal--offline__title--sm dd-m-modal--offline__title--dot">
            Shareable
        </h2>

        <div class="dd-m-modal--offline__description">
            Share the application easily via the page link.
        </div>

        <button type="button"
                v-on:click="changeStep(2)"
                class="dd-m-button dd-m-button--default dd-m-button--assertive">
            Próximo
        </button>
    </div>
</template>

<script>
    export default {
        name: "offline-content-step-1",
        props: ['changeStep']
    }
</script>




// WEBPACK FOOTER //
// resources/site/js/components/offline/offline-content-step-1.vue